import React, { useEffect, useState } from "react";
import styles from "./PrivateProyects.module.scss";
import styled from "styled-components";
import ProfileMenu from "../../../components/Perfil/ProfileMenu/ProfileMenu";
import Loading from "../../UI/Loading/Loading";
import Botonera from "../../Botonera/Botonera";
import NewMaterialBudget from "../../../components/NewMaterialBudget/NewMaterialBudget";
import NewProject from "../../../components/NewProject/NewProject";
import { ReactComponent as Faq } from "../../../assets/svg/FAQ.svg";
import { ReactComponent as Plus } from "../../../assets/svg/plus-icon.svg";
import { connect } from "react-redux";
import Modal from "../../../components/Modal/Modal";
import {
  getDashboardProjects,
  showFiveMore,
  getProjects,
  resetFilterBy,
  getProjectsByType,
  openFeedTextModal,
  clearProjects,
  closeMainModal,
  setProjectFormStyle,
  setSubProjectStyle,
  openTutorialModal,
  resetProjectToEdit,
} from "../../../store/actions";
import EmptyState from "../../UI/EmptyState/EmptyState";
import useSuscriptionModalTimeout from "../../../hooks/useSuscriptionModalTimeout";
import Pagination from "../../../hooks/pagination";
import AllProjectsItemEmptyCard from "../AllProjectsItem/AllProjectsItemEmptyCard";
import FilterPrivateProjects from "../FilterBy/FilterPrivateProjects/FilterPrivateProjects";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StylesMenu = styled.div`
  position: absolute;
`;

function PrivateProjects({
  isLoaded,
  profileMenu,
  page,
  itemCount,
  openVisualizer,
  openTutorialModal,
  allProjects,
  isVisualizerOpen,
  getProjectsByType,
  clearProjects,
  closeMainModal,
  isFilter,
  loading,
  searchParams,
}) {

  const [isOpen, setIsOpen] = useState(false);
  const pageNumberLimit = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const [isOpenMaterialBudget, setIsOpenMaterialBudget] = useState(false);
  const [isOpenProject, setModalOpenProject] = useState(false);
  const [ocultarEnMobile, setOcultarEnMobile] = useState(false);
  const [mobileStylesFromParent, setMobileStylesFromParent] = useState(false);
  useSuscriptionModalTimeout();

  const handleResize = () => {
    const windowWidth = window.innerWidth;
    setOcultarEnMobile(windowWidth < 768);
    setMobileStylesFromParent(windowWidth < 768);
  };

  useEffect(() => {
    handleResize();
    clearProjects();
  }, []);



  // Agregar un event listener para el cambio de tamaño de la ventana
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getProjectsByType("PRIVATE", currentPage, pageNumberLimit);
  }, [currentPage, clearProjects]);


  function setModalOpen(isOpen) {
    closeMainModal();
    setIsOpen(isOpen);
  }

  const handleNewOpenProject = () => {
    resetProjectToEdit();
    setProjectFormStyle(false);
    setModalOpenProject(true);
    closeMainModal();
  };


  const paginationAttributes = {
    currentPage,
    maxPageLimit,
    minPageLimit,
    response: allProjects,
  };

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const onPrevClick = () => {
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageLimit(maxPageLimit - pageNumberLimit);
      setMinPageLimit(minPageLimit - pageNumberLimit);
    }
    setCurrentPage((prev) => prev - 1);
  };

  const onNextClick = () => {
    if (currentPage + 1 > maxPageLimit) {
      setMaxPageLimit(maxPageLimit + pageNumberLimit);
      setMinPageLimit(minPageLimit + pageNumberLimit);
    }
    setCurrentPage((prev) => prev + 1);
  };

  return (
    <>
      <Container>
        <Wrapper className={openVisualizer ? isVisualizerOpen : ""}>
          {ocultarEnMobile ? <Botonera mobileStylesFromParent={mobileStylesFromParent} /> :
            null}
          <div className={styles.container}>
            <div className={styles.mainTitle}>
              Obras privadas
              <div className={styles.mainTitle_iconsContainer}>
                <div className={styles.mainTitle_iconsContainer_createPublication} onClick={() => handleNewOpenProject()}>
                  <Plus height={20} width={20} />
                </div>
                <div className={styles.mainTitle_faq} onClick={() => openTutorialModal()}>
                  <Faq height={20} width={20} />
                </div>
              </div>
            </div>
            <FilterPrivateProjects />
            {Array.isArray(allProjects) && allProjects.length === 0 && !loading ? (
              <div className={styles.emptyState}>
                <EmptyState title="No hay resultados para su búsqueda." />
              </div>
            ) : loading ? (
              <Loading noModal />
            ) : <div className={styles.AllProjects} id="allProjects">
              {allProjects?.itemCount || allProjects?.length > 0 ? (
                <Pagination
                  {...paginationAttributes}
                  onPrevClick={onPrevClick}
                  onNextClick={onNextClick}
                  onPageChange={onPageChange}
                  setModalOpen={setModalOpen}
                  isOpen={isOpen}
                />
              ) : (
                <AllProjectsItemEmptyCard
                  setModalOpenProject={setModalOpenProject}
                  isOpen={isOpenProject} />
              )}
            </div>}
          </div>
        </Wrapper>
        <Modal isOpen={isOpenMaterialBudget}>
          <NewMaterialBudget closeModal={() => setIsOpenMaterialBudget(false)} />
        </Modal>
        <Modal isOpen={isOpenProject}>
          <NewProject closeModal={() => setModalOpenProject(false)} />
        </Modal>
      </Container>

    </>
  );
}

const mapStateToProps = (state) => {
  return {
    profileMenu: state.profile.menuShow,
    loading: state.dashboard.loading,
    allProjects: state.dashboard.viewProjects,
    searchParams: state.dashboard.searchParams,
    isFilter: state.dashboard.isFilter,
    page: state.dashboard.page,
    itemCount: state.dashboard.itemCount,
    take: state.dashboard.take,
    showButton: state.dashboard.allProjects,
    proyectos: state.profile.proyectos,
    postulaciones: state.profile.postulations,
    isLoaded: state.general.isLoaded,
    isVisualizerOpen: state.general.recoverOpen,
    publicFilter: state.general.publicFilter,
    privateFilter: state.general.privateFilter,
    tutorialModal: state.dashboard.tutorialModal,
  };
};

export default connect(mapStateToProps, {
  getDashboardProjects,
  getProjectsByType,
  showFiveMore,
  getProjects,
  resetFilterBy,
  clearProjects,
  closeMainModal,
  setProjectFormStyle,
  setSubProjectStyle,
  resetProjectToEdit,
  openFeedTextModal,
  openTutorialModal,
})(PrivateProjects);
